module.exports = "/_next/static/images/8eba131ecb2f2384dc16ebc55b2f800b-man-looking-up-smiling-xs@3x.jpg.webp";